var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.texts)?_c('div',{staticClass:"reco-desc"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.texts.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }